import React, {useEffect, useRef, useState} from "react"
import './edit-dogovor.scss'
import LoadPanel from "devextreme-react/load-panel";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faFileLines} from "@fortawesome/free-solid-svg-icons";
import Form, {
    ButtonItem, ButtonOptions,
    GroupItem,
    Item,
    Label,
    RequiredRule,
} from "devextreme-react/form";
import ExtFileUploader from "../../components/file-uploader/file-uploader";
import notify from "devextreme/ui/notify";
//import {sendUserRequest} from "../../api/request";
import {useAuth} from "../../contexts/auth";
import {sendUserRequest, sendLettersMailRequest} from "../../api/request";
import ZagolovokFromMenu from "../../components/zagolovok/zagolovok";

const EditDogovorPage = () => {

    const [defaultMessage, setDefaultMessage] = useState('')
    const [defaultType, setDefaultType] = useState(1)
    const [loading, setLoading] = useState(false)
    const extFileUploaderRef = useRef();
    const formData = useRef({})
    const {reqTypes, selectedDog } = useAuth()

    useEffect(() => {
        (async function(){
            setDefaultType(19)
            const newType = reqTypes.find(type=> type.id === 19)
            setDefaultMessage(newType ? newType.defaultText : null)
            setLoading(false)
        })();
    },[reqTypes])

    const onSendRequest = async (e) => {
        e.preventDefault();

        const { message, attachments} = formData.current;
        const fd = new FormData()
        fd.append('typeText',reqTypes.find(type=> type.id === defaultType).name)
        fd.append('message',message)
        fd.append('type',defaultType)//type_request
        //если в заявке обязательные документы
        if ([1,5,7].includes(defaultType) && (attachments === undefined || attachments?.length === 0)) {
            notify('Прикрепите соотвествующий(е) документ(ы)!','error', 5000)
            return
        }

        //если в заявке участвует договор
        if (selectedDog /*&& dogVisibleTypes.includes(defaultType)*/) fd.append('dogovor',selectedDog.kodDog)


        for (let i=0; i<attachments?.length; i++) {
            fd.append('file',attachments[i])
        }
        setLoading(true);

        const result = await sendUserRequest(fd)
        if (result.isOk) { //если успешно создали заявку
            notify(result.message, 'success', 5000);
            extFileUploaderRef.current.clearAttachFiles();
            formData.current.attachments = undefined;

            //#region отмыливаем заявку
            const resultMail = await sendLettersMailRequest(fd);
            if (resultMail.isOk) {
                //если успешно отправили мыло
                console.log(resultMail.message);
            } else {
                console.error(resultMail.message);
            }
            //#endregion
        } else {
            notify(result.message, 'error', 5000);
        }
        setLoading(false)
    }

    const messageOptions = {
        placeholder: 'Введите текст запроса..',
        showClearButton: true,
        value: parseMessage(defaultMessage),
        autoResizeEnabled: true
    }

    //заменим дефолтный текст реквизитами
    function parseMessage(message) {
        if (!message) return null
        let res = message
        if (res.indexOf('<укажите ИНН>') && selectedDog) {
            res = res.replace('<укажите ИНН>', 'ИНН '+selectedDog.inn)
        }
        if (res.indexOf('<укажите номер договора>') && selectedDog) {
            res = res.replace('<укажите номер договора>', selectedDog.ndog)
        }
        if (res.indexOf('<укажите название организации>') && selectedDog) {
            res = res.replace('<укажите название организации>', selectedDog.name)
        }
        return res
    }

    return (
        <div className={'content-block dx-card responsive-paddings popupWithUploader'}>
            <LoadPanel visible={loading} />
            <FontAwesomeIcon className="icon-header-h3 main-color main-color-light" icon={faFileLines} />
            <h3><strong><ZagolovokFromMenu/></strong></h3>
            <form className="px-3" onSubmit={onSendRequest}>
                <Form labelMode={'floating'}
                      labelLocation={'top'}
                      formData={formData.current}
                      id="request-form"
                      colCount={1}
                >
                    <Item dataField="message" editorType="dxTextArea" editorOptions={messageOptions}>
                        <Label text="Текст запроса"/>
                        <RequiredRule message="Введите текст сообщения!" />
                    </Item>
                    <GroupItem caption={""}>
                        <Item>
                            <ExtFileUploader ref={extFileUploaderRef} setfile={(e) => formData.current.attachments = e }></ExtFileUploader>
                        </Item>
                    </GroupItem>
                    <ButtonItem horizontalAlignment="left">
                        <ButtonOptions
                            type={'default'}
                            useSubmitBehavior={true}
                            text="Отправить запрос"
                            icon="email"
                            disabled={loading}
                        >
                        </ButtonOptions>
                    </ButtonItem>
                </Form>
            </form>
        </div>
    )
}

export default EditDogovorPage
